/**
 * Selector of focusable native elements
 */
export const IMPLICIT_FOCUSABLE_ELEMENT_SELECTOR = `
  a[href]:not([hidden]):not([inert]), 
  area[href]:not([hidden]):not([inert]), 
  audio[controls]:not([hidden]):not([inert]), 
  button:not([disabled]):not([hidden]):not([inert]), 
  details summary:not([hidden]):not([inert]), 
  embed:not([hidden]):not([inert]),
  iframe:not([hidden]):not([inert]), 
  img[usemap]:not([hidden]):not([inert]),
  input:not([disabled]):not([type="hidden"]):not([hidden]):not([inert]), 
  select:not([disabled]):not([hidden]):not([inert]), 
  textarea:not([disabled]):not([hidden]):not([inert]), 
  video[controls]:not([hidden]):not([inert]), 
  [contenteditable]:not([disabled]):not([hidden]):not([inert])
`
  .trim()
  .replace(/\s+/g, ' ');

/**
 * Selector of focusable native elements and elements that use `tabindex` attribute
 * Used inside util function like `isFocusable`
 */
export const FOCUSABLE_ELEMENT_SELECTOR =
  IMPLICIT_FOCUSABLE_ELEMENT_SELECTOR +
  ', [tabindex]:not([disabled]):not([hidden]):not([inert])';
